import { LitElement, html } from '@hh/global.js'

class SearchLandingFilters extends LitElement {
  static properties = {
    open: {
      type: Boolean,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleToggleFilterDrawer()
    this.checkNoResults()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleToggleFilterDrawer() {
    const buttonEls = this.querySelectorAll('.js-toggle-filter-button')
    const sectionEl = this.closest('.search-landing')
    const searchLandingFilterDrawer = sectionEl.querySelector(
      'search-landing-filter-drawer'
    )

    buttonEls?.forEach((el) => {
      el.addEventListener('click', () => {
        searchLandingFilterDrawer.toggleAttribute('open')
      })
    })
  }

  checkNoResults() {
    const counts = Number(this.closest('.search-landing__header').querySelector('.kuResultsNumber').innerHTML.trim()) || 0
    if (counts === 0) {
      this.closest('main').classList.add('klevu-search__no-results')
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('search-landing-filters', SearchLandingFilters)

class SearchLandingFilterDrawer extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleRefreshState()
    this.handleCloseTrigger()
    this.handleEscKey()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updated() {
    const sectionEl = this.closest('.search-landing')

    const toggleButton = this.closest('.search-landing').querySelectorAll(
      '.js-toggle-filter-button'
    )

    if (this.open) {
      toggleButton?.forEach((el) => {
        el.classList.add('is-show')
      })

      sectionEl.setAttribute('data-animate-switch', '')
      setTimeout(() => {
        sectionEl.removeAttribute('data-animate-switch')
        sectionEl.classList.add('search-filter-drawer-open')
      }, 500)
    } else {
      toggleButton?.forEach((el) => {
        el.classList.remove('is-show')
      })

      sectionEl.setAttribute('data-animate-switch', '')
      setTimeout(() => {
        sectionEl.removeAttribute('data-animate-switch')
        sectionEl.classList.remove('search-filter-drawer-open')
      }, 500)
    }
  }

  handleRefreshState() {
    const sectionEl = this.closest('.search-landing')
    const isFilterDrawerOpen = sectionEl.classList.contains(
      'search-filter-drawer-open'
    )

    if (!isFilterDrawerOpen) return
    this.setAttribute('open', '')
  }

  closeDrawer() {
    this.removeAttribute('open')
  }

  handleCloseTrigger() {
    const filterDrawerClose = this.querySelectorAll(
      '.js-search-landing-filter-drawer-close'
    )

    filterDrawerClose?.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeDrawer()
      })
    })
  }

  handleEscKey() {
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDrawer()
      }
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('search-landing-filter-drawer', SearchLandingFilterDrawer)
